import React, { useEffect, useRef, useState } from 'react'
import { Link } from 'react-router-dom'
import FeaturedStylistCard from './Cards/FeaturedStylistCard'
import SliderLeftBlackIcon from '../../assets/imgs/slider-left-icon-black.png'
import SliderRightBlackIcon from '../../assets/imgs/slider-right-icon-black.png'
import { getDataById } from '../../apis/generalApis'

const ViewProfileHistory = () => {
  const user = JSON.parse(localStorage.getItem('user'))
  const viewProfileHistory = useRef(null)
  const scroll = (scrollValue) => {
    viewProfileHistory.current.scrollLeft += scrollValue
  }
  const [isLoading, setIsLoading] = useState(false)
  const [viewedStylists, setViewedStylists] = useState([])
  const [favouriteStylists, setFavouriteStylists] = React.useState([])

  useEffect(() => {
    getProfileReviews()
    getFavouriteStylists()
  }, [])

  const getProfileReviews = async () => {
    let body = {
      user_id: 1,
    }
    setIsLoading(true)
    let result = await getDataById('view-profile-history', body)
    setIsLoading(false)
    if (result?.data != null && result?.success === true) {
      setViewedStylists(result?.data)
    }
  }
  const getFavouriteStylists = async () => {
    try {
      let result = await getDataById('show-favorite-stylists', {
        user_id: user?.id,
      })
      if (result?.success === true) {
        setFavouriteStylists(result?.data?.stylist)
      }
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <div className="view-profile-history text-center">
      <h1 className="section-heading text-black fw-bold">
        View Profile History
      </h1>
      <div className="position-relative">
        <img
          src={SliderLeftBlackIcon}
          alt="Slider Icon"
          className="service-slider-icon client pointer left"
          onClick={() => scroll(-500)}
        />
        <img
          src={SliderRightBlackIcon}
          alt="Slider Icon"
          className="service-slider-icon client pointer"
          onClick={() => scroll(500)}
        />
        <div
          className="row flex-nowrap overflow-auto m-0 mt-5 pb-3"
          style={{ paddingLeft: '4rem', scrollBehavior: 'smooth' }}
          ref={viewProfileHistory}
        >
          {viewedStylists?.map(
            (stylist, index) =>
              index < 15 && (
                <div
                  className="col-8 col-sm-6 col-md-5 col-lg-4"
                  key={stylist?.id}
                >
                  {/* <Link
                to={`/stylist-profile/${stylist?.id}`}
                className="text-decoration-none text-black"
              > */}
                  <FeaturedStylistCard
                    stylist={stylist}
                    action={
                      favouriteStylists?.find((el) => el?.id === stylist?.id)
                        ? 'remove-favourite'
                        : 'add-favourite'
                    }
                    isFavourite={
                      favouriteStylists?.find((el) => el?.id === stylist?.id)
                        ? true
                        : false
                    }
                    getFavouriteStylists={getFavouriteStylists}
                    getProfileReviews={getProfileReviews}
                  />
                  {/* </Link> */}
                </div>
              ),
          )}
        </div>
      </div>
    </div>
  )
}

export default ViewProfileHistory
